  /**
   * @memberof SMART2
   * @ngdoc directive
   * @name Checkbox
   * @description This directive is useful for creating a checkbox.
   *
   * @attr {String} label
   *    Label to be displayed for identification of this ui element
   * @attr {Boolean} ng-model
   *    Checkbox's default state (selected or unselected)
   * @attr {Object} ng-model-options
   *    https://docs.angularjs.org/api/ng/directive/ngModelOptions. 
   *    <a href="SMART2.Textfield.html">Click here</a> and scoll down to 'Textfield with ng-model-options' to see example reference.
   * @attr {Boolean} disable
   *    If value of this attribute is set to true, checkbox will not be clickable
   * @attr {Boolean} focus 
   *    If set to true, this ui element will be focused
   * @attr {Boolean} validate
   *    If set to true, this ui element will be validated on the basis of rules passed to it
   * @attr {Array} rules 
   *    Rules to be evaluated when this element's blur event is fired. A rule must have 'rule' and 'errorMessage' properties (keys).
   *    'rule' must be a condition or group of conditions. 'errorMessage' will be the message to be displayed when corresponding rule fails. See example for more.
   * @attr {String} error-message 
   *    Error message to be displayed. This attribute can be set at any point to display an error message.
   * @attr {Boolean} is-mandatory 
   *    If set to true, default error message will be displayed when blur event is fired and this ui element is left blank
   * @attr {Boolean} is-visible 
   *    If set to true, this ui element will be displayed on form regardless of 'is-mandatory' property's value. 
   *    This ui element can be removed from form by clicking 'x' button on top right corner of this ui element.
   * @attr {Number} colspan
   *    Number of columns to be occupied by this ui element. 1 column is equal to 1 ui element.
   *    Default value is 1.
   *    For e.g. If colspan is set to 2, this ui element will occupy width of 2 ui elements (fields).
   * @attr {Function} on-change
   *    Callback function when checkbox state is changed 
   * 
   * @example
   Dynamic:
   Controller:
       $scope.config = {
            "modelData": {
                "isUrgent": true
            }, 
            "formConfig": {
                "sections": [
                    {
                        "isMandatory": true,
                        "rows": [
                            {
                                "properties": [
                                    {
                                        "label": "Urgent",
                                        "type": "checkbox",
                                        "isMandatory": true,
                                        "data": "isUrgent",
                                        "colspan": 1,
                                        "onChange": "onChange"  //  controller function ,
                                        "attributes": {
                                            "fill": true
                                        },
                                        "rules": [
                                            { 
                                                "rule": "this == true", 
                                                "error": "Checkbox should not be selected" 
                                            }
                                        ]
                                    }
                                ]    
                            }
                        ]
                    }
                ]
            }
        };
    Usage:
        <smart-form-widget form-config="config.formConfig" model-data="config.modelData"></smart-form-widget>
   
   * @example
   Static:
   Controller:
       $scope.isUrgent = true;
       $scope.onChange = function(isUrgent) {
           console.log(isUrgent);
       };
   Usage:
       <smart-checkbox label="Urgent" ng-model="isUrgent" on-change="onChange(isUrgent)"></smart-checkbox>
       
   * @example
   Disabled checkbox:
   <smart-checkbox disable="true"></smart-checkbox>     
   */
  

(function() {
    'use strict';
    var checkboxIds = [];
    var checkboxCounter = 0;
    
    angular.module('SMART2').directive('smartCheckbox', ['$timeout', 'ScrollTo', 'RuleEngine', function ($timeout, ScrollTo, RuleEngine) {
        return {
            restrict: 'E',
            replace: true,
            require: '?ngModel',
            scope: {
                //ngModel: '=?',
                ngModelResolve: '&',
                disable: '@',
                isMandatory: '@',
                isVisible: '=?',
                label: '@',
                minHeight: '@',
                fill: '@',
                rules: '@',
                validate: '=?',
                focus: '=?',
                parentElement: '@',
                errorMessage: '@',
                onChange: '&',
                removable: '@',
                showTooltip: '@',
                tooltipPosition: '@',
                showinfo: '@'
            },
            link: function (scope, element, attrs, ngModelCtrl) {
                checkboxCounter++;
                scope.checkBoxId = "checkbox-" + checkboxCounter;
                //  following line of code has been added for pendo
                // var tmpId = "checkbox_" + (scope.label ? escape(scope.label).replace(/[&\/\\#,+()$~%.'":*?<>{} ]/g, '_') : checkboxCounter);
                // var tmpElementCount = $('#' + tmpId).length;
                // if(tmpElementCount > 0) {
                //     tmpId = tmpId + '_' + checkboxCounter;
                // }

                var tmpId = '';
                if(attrs.id){
                    tmpId = "checkbox_" + attrs.id;        
                    var tmpElementCount = $('#' + tmpId).length;
                    if(tmpElementCount > 0) {
                        tmpId = tmpId + '_' + checkboxCounter;
                    }
                } else {
                    tmpId = "checkbox_" + checkboxCounter;                   
                }
                element.attr("id", tmpId);
              scope.checkboxFieldId = tmpId;
                scope.isRemovable = scope.$eval(scope.removable) == undefined ? true : scope.$eval(scope.removable);
                scope.showTooltip = (scope.showTooltip == undefined || scope.showTooltip == null) ? false : scope.showTooltip;
                scope.fill = scope.$eval(scope.fill) == undefined ? true : scope.$eval(scope.fill);
                var checkboxEle = element.find(":checkbox");
                /*
                 *  Following code has been added to make ng-model-options work
                 *  ngModelCtrl.$render & ngModelCtrl.$setViewValue serve the purpose
                 */
                try {
                    ngModelCtrl.$render = function () {
                        scope.ngModel = ngModelCtrl.$modelValue;
                    };
                }
                catch (e) { }

                var updateView = function () {
                    try {
                        ngModelCtrl.$setViewValue(scope.ngModel);
                    }
                    catch (e) { }
                };


                /*
                 * Focus field when focus is set to true
                 */
                var onFocus = scope.$watch('focus', function (newVal) {
                    if (newVal) {
                        ScrollTo.perform(element, angular.element('#' + scope.parentElement));
                        scope.focus = false;
                    }
                });

                /*
                 * Validate field whene validate is set to true
                 */
                var onValidate = scope.$watch('validate', function (newValue) {
                    if (newValue != undefined && newValue) {
                        scope.validateRules();
                    }
                });

                /*
                 * Validate rules
                 */
                scope.validateRules = function () {
                    scope.validate = false;
                    scope.errorMessage = null;

                    if (scope.rules) {
                        var rules = scope.$eval(scope.rules);
                        var isFoundInvalid = false;

                        for (var i = 0; i < rules.length; i++) {
                            if (typeof rules[i] == 'object') {
                                if (eval((rules[i].rule).replace(/this/g, 'scope.ngModel'))) {
                                    scope.validate = true;
                                    scope.errorMessage = rules[i].error;
                                    break;
                                }
                                else {
                                    if (!isFoundInvalid) {
                                        RuleEngine.isValid(rules[i], function (e) {
                                            scope.validate = true;
                                            scope.errorMessage = e.errorData.error;
                                            isFoundInvalid = true;
                                        });
                                    }
                                    else {
                                        break;
                                    }
                                }
                            }
                        }
                    }
                };


                scope.ngChange = function () {
                    if (attrs.ngModelResolve) {
                        var isChecked = checkboxEle.prop('checked');
                        checkboxEle.prop('checked', !isChecked);
                        ngModelCtrl.$setViewValue(!isChecked);
                        scope.ngModel = !isChecked;

                        scope.ngModelResolve({
                            $event: {
                                isChecked: !checkboxEle.prop('checked'),
                                resolveFun: function (checked) {
                                    checkboxEle.prop('checked', checked);
                                    ngModelCtrl.$setViewValue(checked);
                                    scope.ngModel = checked;
                                    updateView();
                                    scope.validateRules();
                                    var timeout = $timeout(function () {
                                        scope.onChange();
                                        $timeout.cancel(timeout);
                                    });
                                }
                            }
                        });
                    } else {
                        updateView();
                        scope.validateRules();
                        var timeout = $timeout(function () {
                            scope.onChange();
                            $timeout.cancel(timeout);
                        });
                    };
                };


                scope.$on('$destroy', function () {
                    onFocus();
                    onValidate();
                    element.remove();
                    scope = null;
                });
            },
            templateUrl: 'shared/directives/uiElements/smartCheckBox/smartCheckBoxTemplate.html'
        };
    }]);
})();
